// ===== Packages =====

import {
    collection,
    getFirestore,
    onSnapshot,
    query,
    Unsubscribe,
    where,
}                           from 'firebase/firestore';

// ===== Interfaces =====

import {
    IPostEngagementItem,
}                           from '../interfaces';

// ===== Enums =====

import {
    FIRESTORE_COLLECTION,
}                           from '../enums';

const subscribeToPostEngagementItems = ({
    test,
    postId,
    onNext,
}: {
    test: boolean,
    postId: string,
    onNext: (postEngagementItems: Map<string, IPostEngagementItem>) => void,
}): Unsubscribe => {
    const firestore = getFirestore();
    const postEngagementCollection = test
        ? FIRESTORE_COLLECTION.stagingPostEngagement
        : FIRESTORE_COLLECTION.postEngagement;

    return onSnapshot(
        query(
            collection(firestore, postEngagementCollection),
            where('postId', '==', postId),
        ),
        (snapshot) => {
            const nextItems = new Map<string, IPostEngagementItem>();
            snapshot.forEach((docSnapshot) => {
                nextItems.set(docSnapshot.id, docSnapshot.data() as IPostEngagementItem);
            });
            onNext(nextItems);
        },
        () => onNext(new Map()),
    );
};

export default subscribeToPostEngagementItems;
